import { usePropertyHeroForOrgProperty } from '@/Client/State';
import { css } from '@emotion/react';
import { ApiOrgProperty } from '@kaiizen/kai-pro-api';
import { COLORS2 } from '../../Styles';

const styles = css`
  width: 120px;
  height: 80px;
  vertical-align: top;
  display: block;
  background-color: ${COLORS2.namedColors.gray};
  object-fit: cover;
`;

export const PropertyListImage = ({ property }: { property: ApiOrgProperty }) => {
  const heroScanPhotoUri = usePropertyHeroForOrgProperty(property);
  return <img src={heroScanPhotoUri} css={styles} alt='' />;
};
